import React, { useState, useEffect } from "react";
import "./Header.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { HashLink as Link } from "react-router-hash-link";
import { useLocation, useNavigate } from "react-router-dom";
import Popover from "@mui/material/Popover";
import ContactUsDialog from "../ContactUsDialog/ContactUsDialog";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isPrivacyPage = location.pathname === "/privacy-policy";
  const isRulePage = location.pathname === "/voting-rule";
  const isTermsOfUse = location.pathname === "/terms-of-use";
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setShowNavbar(true);
    setLastScrollY(window.scrollY);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY <= 10) {
        setShowNavbar(true);
      } else {
        setShowNavbar(currentScrollY < lastScrollY);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const handleMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleContactUsClick = () => {
    if (!dialogOpen) setDialogOpen(true);
  };

  return (
    <div
      className={isMobile ? "donationHeader" : `donationHeader ${showNavbar ? "show" : "hide"}`}
    >
      <div className="headerContainer">
        <Link to="/" state={{ scrollToId: "landingPage" }}>
          <div className="logoContainer">
            <img
              className="amalgamateLogo"
              src="/Assets/Donation/DonationHeader/amalgamateLogoo.svg"
              alt="no logo found"
            />
          </div>
        </Link>

        {!isMobile && (
          <div className="headerTextsContainer">
            <div className="headerTextsContainer2">
              {isPrivacyPage || isRulePage || isTermsOfUse?(
                <Link
                  to="/"
                  state={{ scrollToId: "amalgamateWorks" }}
                  style={{
                    all: "unset",
                    display: "contents",
                    cursor: "pointer",
                  }}
                >
                  <span className="headerText">Features</span>
                </Link>
              ) : (
                <Link
                  to="#amalgamateWorks"
                  smooth
                  style={{
                    all: "unset",
                    display: "contents",
                    cursor: "pointer",
                  }}
                >
                  <span className="headerText">Features</span>
                </Link>
              )}
              {isPrivacyPage || isRulePage || isTermsOfUse? (
                <Link
                  to="/"
                  state={{ scrollToId: "faq" }}
                  style={{
                    all: "unset",
                    display: "contents",
                    cursor: "pointer",
                  }}
                >
                  <span className="headerText">FAQ</span>
                </Link>
              ) : (
                <Link
                  to="#faq"
                  smooth
                  style={{
                    all: "unset",
                    display: "contents",
                    cursor: "pointer",
                  }}
                >
                  <span className="headerText">FAQ</span>
                </Link>
              )}

              <Link
                to="#downloadApp"
                smooth
                style={{ all: "unset", display: "contents", cursor: "pointer" }}
              >
                <span className="headerText">Download App</span>
              </Link>
              <Link to="/donate/voting-rules">
                <span className="headerText">Voting Rules</span>
              </Link>
              <div
                className="howToHelpContainer"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <div className="howToHelpContainer2">
                  <span className="howToHelpText">How To Help</span>
                  <img
                    src="/Assets/Donation/DonationHeader/downArrow.png"
                    alt="no img found"
                    className="downArrow"
                  />
                </div>
              </div>
              <Menu
                disableScrollLock
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{
                  mt: "1px",
                  "& .MuiMenu-paper": {
                    backgroundColor: "black",
                    color: "white",
                    borderRadius: "10px",
                    zIndex: "10000",
                  },
                }}
              >
                <MenuItem
                  onClick={handleClose}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(134, 134, 134, 0.16)" },
                  }}
                >
                  <span className="dialogText">
                    1. Tell everyone you know (Coming Soon!)
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={handleClose}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(134, 134, 134, 0.16)" },
                  }}
                >
                  {isPrivacyPage || isRulePage || isTermsOfUse ? (
                    <Link to="/" state={{ scrollToId: "donationPage" }}>
                      <span className="dialogText">
                        2. Donate so we can tell everyone in the world
                      </span>
                    </Link>
                  ) : (
                    <Link to="#donationPage" smooth>
                      <span className="dialogText">
                        2. Donate so we can tell everyone in the world
                      </span>
                    </Link>
                  )}
                </MenuItem>
                <MenuItem
                  onClick={handleClose}
                  sx={{
                    "&:hover": { backgroundColor: "rgba(134, 134, 134, 0.16)" },
                  }}
                >
                  {isPrivacyPage || isRulePage || isTermsOfUse ? (
                    <Link to="/" state={{ scrollToId: "amalgamateWorks" }}>
                      <span className="dialogText">3. Use the app</span>
                    </Link>
                  ) : (
                    <Link to="#amalgamateWorks" smooth>
                      <span className="dialogText">3. Use the app</span>
                    </Link>
                  )}
                </MenuItem>
              </Menu>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="headerButtonsContainer">
            <Link to="/login">
              <div className="donationLoginContainer">
                <span className="donationLoginText">Login</span>
              </div>
            </Link>
            <Link to="#downloadApp" smooth>
              <div className="donationGetTheAppContainer">
                <span className="donationGetTheAppText">Get The App</span>
              </div>
            </Link>
            <button className="donation-back-hub" onClick={() => navigate('/')}>← Back to Hub</button>
          </div>
        )}
        {isMobile && (
          <div className="mobileMenuIcon" onClick={handleMenuOpen}>
            {/* <MenuIcon fontSize="large" /> */}
            <img
              src="/Assets/Donation/DonationHeader/mobileMenuIcon.svg"
              alt="no img found"
              className="mobileMenuIcon"
            />
          </div>
        )}
      </div>
      <Popover
        open={Boolean(mobileMenuAnchor)}
        anchorEl={mobileMenuAnchor}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="mobileMenuDropdown">
          <div className="headerTextsContainer2">
            {isPrivacyPage || isRulePage || isTermsOfUse ? (
              <Link
                to="/"
                state={{ scrollToId: "amalgamateWorks" }}
                style={{
                  all: "unset",
                  display: "contents",
                  cursor: "pointer",
                }}
                onClick={handleMenuClose}
              >
                <span className="headerText">Features</span>
              </Link>
            ) : (
              <Link
                to="#amalgamateWorks"
                smooth
                style={{
                  all: "unset",
                  display: "contents",
                  cursor: "pointer",
                }}
                onClick={handleMenuClose}
              >
                <span className="headerText">Features</span>
              </Link>
            )}
            {isPrivacyPage || isRulePage | isTermsOfUse ? (
              <Link
                to="/"
                state={{ scrollToId: "faq" }}
                style={{
                  all: "unset",
                  display: "contents",
                  cursor: "pointer",
                }}
                onClick={handleMenuClose}
              >
                <span className="headerText">FAQ</span>
              </Link>
            ) : (
              <Link
                to="#faq"
                smooth
                style={{
                  all: "unset",
                  display: "contents",
                  cursor: "pointer",
                }}
                onClick={handleMenuClose}
              >
                <span className="headerText">FAQ</span>
              </Link>
            )}

            <Link
              to="#downloadApp"
              smooth
              style={{ all: "unset", display: "contents", cursor: "pointer" }}
              onClick={handleMenuClose}
            >
              <span className="headerText">Download App</span>
            </Link>
            <Link to="/donation/voting-rules" onClick={handleMenuClose}>
              <span className="headerText">Voting Rules</span>
            </Link>
            <div
              className="howToHelpContainer"
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <div className="howToHelpContainer2">
                <Accordion
                  disableGutters
                  elevation={0}
                  sx={{
                    backgroundColor: "black",
                    color: "white",
                    borderRadius: "50px",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                  >
                    <Typography
                      className="howToHelpText"
                      sx={{ fontSize: "12px" }}
                    >
                      How to help?
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div
                        className="accordionText"
                        style={{ cursor: "pointer" }}
                        onClick={handleMenuClose}
                      >
                        1. Tell everyone you know (Coming Soon!)
                      </div>

                      <div className="accordionText">
                        {isPrivacyPage || isRulePage || isTermsOfUse ? (
                          <Link
                            to="/"
                            state={{ scrollToId: "donationPage" }}
                            style={{
                              color: "inherit",
                              textDecoration: "none",
                              display: "block",
                            }}
                            onClick={handleMenuClose}
                          >
                            2. Donate so we can tell everyone in the world
                          </Link>
                        ) : (
                          <Link
                            to="#donationPage"
                            smooth
                            style={{
                              color: "inherit",
                              textDecoration: "none",
                              display: "block",
                            }}
                            onClick={handleMenuClose}
                          >
                            2. Donate so we can tell everyone in the world
                          </Link>
                        )}
                      </div>

                      <div className="accordionText">
                        {isPrivacyPage || isRulePage || isTermsOfUse ? (
                          <Link
                            to="/"
                            state={{ scrollToId: "amalgamateWorks" }}
                            style={{
                              color: "inherit",
                              textDecoration: "none",
                              display: "block",
                            }}
                            onClick={handleMenuClose}
                          >
                            3. Use the app
                          </Link>
                        ) : (
                          <Link
                            to="#amalgamateWorks"
                            smooth
                            style={{
                              color: "inherit",
                              textDecoration: "none",
                              display: "block",
                            }}
                            onClick={handleMenuClose}
                          >
                            3. Use the app
                          </Link>
                        )}
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
            <Link
              to="/login"
              style={{ all: "unset", width: "100%" }}
              onClick={handleMenuClose}
            >
              <div className="donationLoginContainer">
                <span className="donationLoginText">Login</span>
              </div>
            </Link>
            <Link
              to="#downloadApp"
              smooth
              style={{ all: "unset", width: "100%" }}
              onClick={handleMenuClose}
            >
              <div className="donationGetTheAppContainer">
                <span className="donationGetTheAppText">Get The App</span>
              </div>
            </Link>
          </div>
        </div>
      </Popover>
      <ContactUsDialog open={dialogOpen} setDialogOpen={setDialogOpen} />
    </div>
  );
}

export default Header;
